import React, { useEffect, useMemo, useState } from 'react';
import { useAPI } from '../../shared/services/api/API';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { WASHUB_CONSTANTS } from '../../shared/Constants';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { IBarCodeDetails, ICollectionOrderTable } from '../models/CollectionPoint';

export const CollectionCenterOrder = () => {
  const { httpPost, handleAlertBar } = useAPI();
  const [barcode, setBarcode] = useState('');
  // const [tables, setTables] = useState<any>([]);
  const [barCodeDetailTable, setBarCodeDetailTable] = useState<any>([]);
  const [collectionOrderData, setCollectionOrderData] = useState<any>({});
  const barcodeRef = React.useRef<HTMLInputElement | null>(null);
  const columns = useMemo<MRT_ColumnDef<ICollectionOrderTable>[]>(
    () => [
      {
        accessorKey: 'employeeId',
        header: 'Employee Id',
        size: 10,
      },
      {
        accessorKey: 'productId',
        header: 'Product Id',
        size: 10,
      },
      {
        accessorKey: 'productName',
        header: 'Product Name',
        size: 10,
      },
      {
        accessorKey: 'itemCount',
        header: 'Item Count',
        size: 50,
      },
    ],
    [],
  );

  const barCodeDetailColumn = useMemo<MRT_ColumnDef<IBarCodeDetails>[]>(
    () => [
      {
        accessorKey: 'employeeId',
        header: 'Employee Id',
        size: 10,
      },
      {
        accessorKey: 'productId',
        header: 'Product Id',
        size: 10,
      },
      {
        accessorKey: 'productName',
        header: 'Product Name',
        size: 10,
      },
      {
        accessorKey: 'campId',
        header: 'Camp Id',
        size: 50,
      },
    ],
    [],
  );

  const createCollectionCenterOrder = async () => {
    const payload: any = {
      barCodeList: barCodeDetailTable?.map((data: any) => data.barCode),
    };
    if (collectionOrderData?.orderId) {
      payload['orderId'] = collectionOrderData.orderId;
    }
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.COLLECTION_CENTER_CREATE_POST}`,
      payload,
    ).then((response) => {
      if (response.status === 200) {
        setCollectionOrderData(response.data);
        // setTables(response?.data?.orderItems);
        setBarCodeDetailTable([]);
        handleAlertBar(
          'success',
          `Collection Center Order Id ${response.data?.orderId}  created successfully`,
        );
      } else {
        if (response.data.error) {
          if (response.data.error) {
            if (response.data.message === 'INVALID_OPERATION') {
              handleAlertBar('error', 'Invalid operation');
            }
          }
        }
      }
    });
  };

  const fetchBarCodeDetail = async (barcode?: string) => {
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.COLLECTION_CENTER_BARCODE_DETAILS_POST}`,
      barcode,
    ).then((response) => {
      if (response.status === 200) {
        const data = response?.data;
        if (data.employeeId === barCodeDetailTable[0]?.employeeId && barCodeDetailTable.length > 0) {
          setBarCodeDetailTable((prev: any) => [...prev, data]); 
        } else  if (barCodeDetailTable.length === 0) {
          setBarCodeDetailTable((prev: any) => [...prev, data]); 
        } else {
              handleAlertBar(
          'error',
          'Barcodes belonging two different employees cannot be scanned in the same order',
        );

        }
        setBarcode('');
        if (barcodeRef.current) {
          barcodeRef.current.focus();
        }
      } else {
        if (response.data.error) {
          if (response.data.error) {
            if (response.data.message === 'INVALID_OPERATION') {
              handleAlertBar('error', 'Invalid operation');
            }
          }
        }
      }
    });
  };

  const handleBarCode = (value: string) => {
    setBarcode(value);
    fetchBarCodeDetail(value);
  };

  const removeBarCode = (barCode: string) => {
    const updatedBarCodeDetails = barCodeDetailTable.filter((data: IBarCodeDetails) => data.barCode !== barCode);;
    setBarCodeDetailTable(updatedBarCodeDetails);
  }
  
  const resetCollectionCenter = () => {
    setBarcode('');
    setCollectionOrderData({});
    // setTables([]);
    if (barcodeRef.current) {
      barcodeRef.current.focus();
    }
  };

  useEffect(() =>{
    if (barcodeRef.current) {
      barcodeRef.current.focus();
    }
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Typography
            color={'primary'}
            sx={{ textAlign: 'center' }}
            variant="h5"
            className="mt-0"
          >
            Collection Center Order
          </Typography>
        </Grid>
      </Grid>

      <div style={{ margin: '5px 15px', borderTop: '2px solid #25BCCA' }}></div>
      <Grid
        container
        display={'flex'}
        flexDirection={'row'}
        className="p-4"
        sx={{ maxHeight: '30vh', overflow: 'auto' }}
      >
        <Grid item xs={12} sm={12} md={7} lg={7}>
          <Grid
              container
              key={'scan'}
              display={'flex'}
              flexDirection={'row'}
              className="mb-4"
            >
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <input
                  type="text"
                  id='barcode'
                  value={barcode}
                  placeholder="Scan the Barcode..."
                  onInput={(e) => handleBarCode((e.target as HTMLInputElement).value)}
                  ref={barcodeRef}
                />
              </Grid>
            </Grid>
        </Grid>
      </Grid>
      <div style={{ padding: '5px 15px', maxHeight: 'auto', overflow: 'auto' }}>
        {barCodeDetailTable.length > 0 && (
          <Paper className="p-2 mb-2">
            <MaterialReactTable
              muiTablePaperProps={{
                elevation: 0,
                sx: {
                  width: '100%',
                  '& .css-1tbggly': {
                    minHeight: '0px',
                  },
                  '& .css-10gei56': {
                    minHeight: '0px',
                  },
                },
              }}
              muiTableContainerProps={{
                sx: {
                  height: 'auto',
                },
              }}
              defaultColumn={{
                maxSize: 150,
                minSize: 10,
                size: 50,
              }}
              columns={barCodeDetailColumn}
              enableFullScreenToggle={false}
              enableStickyHeader
              positionActionsColumn="last"
              enableRowActions={false}
              enableColumnActions={false}
              enableColumnFilters={false}
              enableFilters={false}
              enablePagination={false}
              enableSorting={false}
              enableHiding={false}
              enableDensityToggle={false}
              enableToolbarInternalActions={false}
              data={barCodeDetailTable}
              editDisplayMode="modal"
              renderRowActions={({ row, table }) => (
                          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                  className="ps-1 pe-1"
                                  variant="contained"
                                  sx={{ color: 'red' }}
                                  onClick={() => {
                                      removeBarCode(row.original.barCode);
                                  }}
                                >
                                  <Typography variant="labelNormal">
                                    Delete
                                  </Typography>
                                </Button>
                              </Box>
                        )}
            />
          </Paper>
        )}
      </div>
            <div className="d-flex justify-content-end me-2">
        <Button
          variant="contained"
          className="me-2"
          onClick={() => {
            createCollectionCenterOrder();
          }}
        >
          Create Collection Order
        </Button>
      </div>
    </div>
  );
};
